import React from "react"
import PropTypes from "prop-types"
import SbEditable from "storyblok-react"
import { unified } from "unified"
import remarkParse from "remark-parse"
import remarkRehype from "remark-rehype"
import rehypeReact from "rehype-react"
import remarkReactComponents from "../../helpers/remarkReactComponents"

const History = ({ blok }) => (
  <SbEditable content={blok}>
    <div className="history">
      <div className="history__title">{blok.date}</div>
      {
        unified()
          .use(remarkParse)
          .use(remarkRehype)
          .use(rehypeReact, {
            createElement: React.createElement,
            components: remarkReactComponents,
            Fragment: React.Fragment,
          })
          .processSync(blok.copy).result
      }
    </div>
  </SbEditable>
)

History.propTypes = {
  blok: PropTypes.shape({
    date: PropTypes.string,
    copy: PropTypes.string,
  }).isRequired,
}

export default History
